import { invoke } from "@tauri-apps/api/core";

export type NativeAttachmentFile = {
  name: string;
  contentType: string;
  data: string;
};

/** Base64 decoded this many characters at a time (a multiple of 4). */
const DECODE_CHUNK = 1 << 20;

/**
 * Base64 as bytes, a chunk at a time with a plain loop: a 20 MB file never
 * becomes one huge binary string, nor a call per byte.
 */
function base64Bytes(data: string): Uint8Array<ArrayBuffer> {
  const padding = data.endsWith("==") ? 2 : data.endsWith("=") ? 1 : 0;
  const bytes = new Uint8Array((data.length / 4) * 3 - padding);
  let offset = 0;
  for (let start = 0; start < data.length; start += DECODE_CHUNK) {
    const binary = atob(data.slice(start, start + DECODE_CHUNK));
    for (let index = 0; index < binary.length; index += 1) {
      bytes[offset + index] = binary.charCodeAt(index);
    }
    offset += binary.length;
  }
  return bytes;
}

export function nativeAttachmentFile(file: NativeAttachmentFile): File {
  return new File([base64Bytes(file.data)], file.name, {
    type: file.contentType,
  });
}

/** Reads a file the OS granted this window (a drop or a native pick) once. */
export async function readNativeDroppedFile(path: string): Promise<File> {
  return nativeAttachmentFile(
    await invoke<NativeAttachmentFile>("read_dropped_file", { path }),
  );
}

export async function readNativeClipboardFiles(): Promise<File[]> {
  const files = await invoke<NativeAttachmentFile[]>("read_clipboard_files");
  return files.map(nativeAttachmentFile);
}
